__turbopack_context__.v({
  "spin": "LoadingSpinner-module-scss-module__pnQSVG__spin",
  "spinnerRoot": "LoadingSpinner-module-scss-module__pnQSVG__spinnerRoot",
});
